import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Acesso } from 'src/app/models/bas/acesso/acesso';
import { AbstractIdbaRequestModel } from 'src/app/shared/models/abstract-idba-request-model';
import { AbstractIdbaService } from 'src/app/shared/utils/abstract-idba-service.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class AcessoService extends AbstractIdbaService {

  override model: Acesso;

  constructor(http: HttpClient) { 
    super(http, new Acesso());
    this.programName = "bas/acesso/acesso.p";
  }

  pesquisaPermissoAcesso()
  {
    const request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-retorna-permissao-acesso";
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  pesquisaAcessoPrograma(rowid: string)
  {
    const request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-retorna-acesso-programa";
    request.parameters = {rowid}; 
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  consultaPermissaoUsuario(rowid: string){
    const request = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-consulta-permissao-usuario";
    request.parameters = { rowid };
      return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  pesquisaPermissaoFuncao(rowid: string){
    const request = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-retorna-funcao-usuario-programa";
    request.parameters = { rowid };
      return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  pesquisaLogAcesso(registro: any){
    const request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = 'bas/acesso/logacesso.p';
    registro.codigoPrograma ? request.procedure = 'pi-pesquisar-usuario-programa' : request.procedure = 'pi-pesquisar-usuario';
    request.parameters = registro;
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  copiaPermissoesAcesso(usuarioOrigem: string, usuarioDestino: string){
    const request = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-copia-permissoes-acesso";
    request.parameters = { usuarioOrigem, usuarioDestino };
      return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }
}
